import React, { useState, useEffect } from 'react'
import { Box, Typography, Button } from '@mui/material'
import { Navbar } from '../../component/shared/Navbar'
import { Helmet } from 'react-helmet-async'
import { useSearchParams, Link } from 'react-router-dom'
import { AccountSummary } from './AccountSummary'
import { PurchaseHistory } from './PurchaseHistory'
import { Collapsible } from './Collapsible'
import { useAuth } from '../../api/context/UserAuthContext'

export const MultiCompaniesPointDetails = ({
  title,
  useGetPoint,
  backLink,
  accountSummary = [],
  purchaseHistory = [],
  customerId,
  hiddenColumns = [],
}) => {
  const [searchParams] = useSearchParams()
  const idParams = customerId ?? searchParams.get('id')
  const { user } = useAuth()
  const [salesId, setSalesId] = useState()

  const { data = {}, isLoading } = useGetPoint({
    customerId: idParams,
    ...(salesId ? { salesId } : {}),
  })

  const details = data?.details || {}

  useEffect(() => {
    if (!user?.isPointSystemAdmin && user?.salesId) {
      setSalesId(user?.salesId)
    }
  }, [user])

  return (
    <>
      <Helmet titleTemplate='%s | Point System' defaultTitle='Point System'>
        <title>{title}</title>
      </Helmet>
      <Navbar />
      <Box
        display='flex'
        justifyContent='space-between'
        flexDirection='row'
        px={{ xs: 3, md: 8 }}
        pt={3}
      >
        <Typography variant='h1'>Order History</Typography>
        <Button variant='outlined' component={Link} to={`/${backLink}`}>
          Back
        </Button>
      </Box>
      <Box pt={5} pb={10} px={{ xs: 3, sm: 5, md: 10 }}>
        <AccountSummary data={data} isLoading={isLoading} columns={accountSummary} />
        {Object.keys(details).map((key) => {
          const companyData = details[key]
          const item = companyData[0]
          return (
            <Box key={key} mt={4}>
              <Collapsible
                label={`${item.companyName} • ${
                  item.companyAccountId
                } • ${item.htgCompany.toUpperCase()}`}
              >
                <PurchaseHistory
                  data={companyData}
                  additionalInfo={purchaseHistory}
                  hiddenColumns={hiddenColumns}
                />
              </Collapsible>
            </Box>
          )
        })}
      </Box>
    </>
  )
}
